import { render, staticRenderFns } from "./SearchedWord.vue?vue&type=template&id=664caf51&scoped=true"
import script from "./SearchedWord.vue?vue&type=script&lang=js"
export * from "./SearchedWord.vue?vue&type=script&lang=js"
import style0 from "./SearchedWord.vue?vue&type=style&index=0&id=664caf51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664caf51",
  null
  
)

export default component.exports